export class UploadDocument {
    value: string;
    displayName: string;

    constructor(value: string, displayName: string) {
        this.value = value;
        this.displayName = displayName;
    }
}
